// DTM
import React, { Component } from "react";
import styled from "styled-components";

import CircularProgress from "@material-ui/core/CircularProgress";

import scale from "../helper/scaling";

import ArticleAbstract, { FlatBody } from "./ArticleAbstract";

const Wrapper = styled.div`
  width: 100%;
  float: left;
  @media (min-width: 1400px) {
    width: 1400px;
    margin: 0 calc(50% - 700px);
  }
`;
const Inner = styled.div`
  margin: 0 25px 25px 25px;
  width: calc(100% - 50px);
  position: relative;

  background-image: url("/assets/noise-pattern@2x.png");
  background-size: 200px 200px;

  display: grid;
  grid-template-columns: calc(50% - 424px) 470px calc(50% - 46px);
  grid-template-rows: auto max-content auto;
  @media (max-width: 1100px) {
    grid-template-columns: 100px calc(50% - 54px) calc(50% - 46px);
  }
  @media (max-width: 700px) {
    display: block;
    width: 100%;
    margin: 0 0 23px 0;
    padding: 27px 0 31px 0;
    float: left;
  }
`;
const Title = styled.div`
  width: 1040px;
  padding: 51px calc(50% - 520px) 55px calc(50% - 520px);

  grid-column: 1 / 4;
  grid-row: 1 / 2;

  font-family: Neuton;
  font-size: 38px;
  font-weight: 600;
  font-style: italic;
  font-stretch: normal;
  line-height: 58px;
  letter-spacing: 0.5px;
  text-align: center;
  color: rgba(0, 0, 0, 0.85);
  @media (max-width: 1100px) {
    width: calc(100% - 50px);
    padding: ${scale(1100, 700, 51, 25, "vw")} 25px
      ${scale(1100, 700, 55, 29, "vw")} 25px;

    font-size: ${scale(1100, 700, 38, 26, "vw")};
    line-height: ${scale(1100, 700, 58, 26 * 1.38, "vw")};
  }
  @media (max-width: 700px) {
    font-size: 26px;
    line-height: 1.38;
    letter-spacing: 0.4px;

    padding: 0 23px 16px 23px;
  }
`;
const ImageContainer = styled.div`
  grid-column: 2 / 3;
  grid-row: 2 / 4;

  width: 100%;

  position: relative;

  @media (max-width: 700px) {
    width: calc(100% - 22px);
    margin: 0 11px;
  }
`;
const BodyContainer = styled.div`
  grid-column: 3 / 4;
  grid-row: 2 / 3;

  margin: 12px calc(100% - ${336 + 23}px) 44px 23px;

  width: 336px;
  @media (max-width: 1100px) {
    margin: 12px 100px 44px 23px;
    width: calc(100% - 123px);
  }
  @media (max-width: 700px) {
    width: calc(100% - 46px);
    margin: 18px 23px 0 23px;
  }
`;
const WhiteLeft = styled.div`
  grid-column: 1 / 2;
  grid-row: 3 / 4;
  background-color: white;

  @media (max-width: 700px) {
    width: 0;
    height: 0;
    display: none;
    overflow: hidden;
  }
`;
const WhiteRight = styled.div`
  grid-column: 3 / 4;
  grid-row: 3 / 4;
  background-color: white;

  @media (max-width: 700px) {
    width: 0;
    height: 0;
    display: none;
    overflow: hidden;
  }
`;
const ButtonLeft = styled.a`
  width: 17px;
  height: 34px;
  display: block;

  cursor: pointer;

  position: absolute;
  top: 294px;
  left: calc(50% - 537px);

  opacity: ${props => (props.dissabled ? "0.3" : "1")};
  cursor: ${props => (props.dissabled ? "default" : "pointer")};

  svg {
    height: 100%;
  }

  @media (max-width: 1400px) {
    left: ${scale(1400, 1100, 138, 40, "vw")};
  }
  @media (max-width: 1100px) {
    left: 40px;
    top: ${scale(1100, 700, 294, 155, "vw")};
  }
  @media (max-width: 700px) {
    width: 0;
    height: 0;
    left: 0;
    top: 0;
    display: none;
    overflow: hidden;
  }
`;
const ButtonRight = styled.a`
  width: 17px;
  height: 34px;
  display: block;

  cursor: pointer;

  position: absolute;
  top: 294px;
  right: calc(50% - 537px);

  opacity: ${props => (props.dissabled ? "0.3" : "1")};
  cursor: ${props => (props.dissabled ? "default" : "pointer")};

  svg {
    height: 100%;
  }

  @media (max-width: 1400px) {
    right: ${scale(1400, 1100, 138, 40, "vw")};
  }
  @media (max-width: 1100px) {
    right: 40px;
    top: ${scale(1100, 700, 294, 155, "vw")};
  }
  @media (max-width: 700px) {
    width: 0;
    height: 0;
    right: 0;
    top: 0;
    display: none;
    overflow: hidden;
  }
`;
const ButtonLeftMobile = styled.a`
  position: absolute;
  width: 0;
  height: 0;
  left: 0;
  top: 0;
  display: none;
  overflow: hidden;
  cursor: pointer;
  opacity: ${props => (props.dissabled ? "0.3" : "1")};
  cursor: ${props => (props.dissabled ? "default" : "pointer")};
  @media (max-width: 700px) {
    width: 49px;
    height: 100%;
    display: block;
  }
`;
const ButtonRightMobile = styled.a`
  position: absolute;
  width: 0;
  height: 0;
  right: 0;
  top: 0;
  display: none;
  overflow: hidden;
  cursor: pointer;
  opacity: ${props => (props.dissabled ? "0.3" : "1")};
  cursor: ${props => (props.dissabled ? "default" : "pointer")};
  @media (max-width: 700px) {
    width: 49px;
    height: 100%;
    display: block;
  }
`;
const ButtonMobileSvgContainer = styled.div`
  position: absolute;

  left: 18px;
  top: 105px;

  height: 26px;
  width: 13px;

  filter: drop-shadow(0px 0px 3px rgba(0, 0, 0, 1));

  svg {
    height: 100%;
    width: 100%;
  }
`;

const Image = styled.img`
  width: calc(100% - 40px);
  border: 20px solid #ffffff;
  display: block;
  @media (max-width: 700px) {
    width: calc(100% - 24px);
    border: 12px solid #ffffff;
  }
`;

class SetHeaderHighlights extends ArticleAbstract {
  constructor(props) {
    super(props);
    this.state = {
      index: 0,
      imageLoaded: false
    };
  }

  clickHandler = offset => () => {
    let index = this.state.index + offset;
    if (index < 0) index = 0;
    if (index > this.props.set.length - 2) index = this.props.set.length - 2;
    if (index !== this.state.index) {
      this.setState({ index: index, imageLoaded: false });
    }
  };

  imageLoadHandler() {
    this.setState({ imageLoaded: true });
  }

  render() {
    let first = this.props.set[0];
    let items = [];
    for (let i in this.props.set) {
      if (i > 0) items.push(this.props.set[i]);
    }
    return (
      <Wrapper>
        <Inner>
          <Title>{first.title}</Title>
          <ImageContainer>
            <Image
              src={items[this.state.index].images.intro.url}
              onLoad={this.imageLoadHandler.bind(this)}
            />
            <ButtonLeftMobile
              onClick={this.clickHandler(-1)}
              dissabled={this.state.index === 0}
            >
              <ButtonMobileSvgContainer>
                <ArrowLeftMobile />
              </ButtonMobileSvgContainer>
            </ButtonLeftMobile>
            <ButtonRightMobile
              onClick={this.clickHandler(1)}
              dissabled={this.state.index === this.props.set.length - 2}
            >
              <ButtonMobileSvgContainer>
                <ArrowRightMobile />
              </ButtonMobileSvgContainer>
            </ButtonRightMobile>
          </ImageContainer>
          <BodyContainer>
            <HeaderHighlightBody
              content={items[this.state.index]}
              showContent={this.state.imageLoaded}
            />
          </BodyContainer>
          <WhiteLeft />
          <WhiteRight />
          <ButtonLeft
            onClick={this.clickHandler(-1)}
            dissabled={this.state.index === 0}
          >
            <ArrowLeft />
          </ButtonLeft>
          <ButtonRight
            onClick={this.clickHandler(1)}
            dissabled={this.state.index === this.props.set.length - 2}
          >
            <ArrowRight />
          </ButtonRight>
        </Inner>
      </Wrapper>
    );
  }
}

export default SetHeaderHighlights;

const BodyWrapper = styled.div`
  width: 100%;
  float: left;
`;
const HighlightTitle = styled.div`
  width: 100%;

  font-family: Lato;
  font-size: 22px;
  line-height: 1.73;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: 0.4px;
  color: rgba(0, 0, 0, 0.85);

  margin-bottom: 10px;

  @media (max-width: 1100px) {
    font-size: ${scale(1100, 700, 22, 14, "vw")};

    margin-bottom: ${scale(1100, 700, 10, 5, "vw")};
  }

  @media (max-width: 700px) {
    font-size: 14px;
    line-height: 1.71;
    letter-spacing: 0.3px;

    margin-bottom: 5px;
  }
`;
const HighlightBody = styled.div`
  width: 100%;

  font-family: Lato;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 1.64;
  letter-spacing: 1px;
  color: rgba(0, 0, 0, 0.85);

  @media (max-width: 1100px) {
    font-size: ${scale(1100, 700, 14, 11, "vw")};
    line-height: ${scale(1100, 700, 14 * 1.64, 11 * 1.91, "vw")};
  }

  @media (max-width: 700px) {
    font-size: 11px;
    line-height: 1.91;
    letter-spacing: 0.8px;
  }
`;
class HeaderHighlightBody extends ArticleAbstract {
  render() {
    return this.props.showContent ? (
      <BodyWrapper>
        <HighlightTitle>{this.title()}</HighlightTitle>
        <HighlightBody>
          <FlatBody>{this.body()}</FlatBody>
        </HighlightBody>
      </BodyWrapper>
    ) : (
      <CircularProgress />
    );
  }
}

class ArrowLeft extends Component {
  render() {
    return (
      <svg
        width="19px"
        height="35px"
        viewBox="0 0 19 35"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g
          id="Page-1"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g
            id="Highlights"
            transform="translate(-139.000000, -389.000000)"
            stroke="#3949AB"
          >
            <polyline id="arrow-left" points="157 389 140 406.228306 157 423" />
          </g>
        </g>
      </svg>
    );
  }
}

class ArrowRight extends Component {
  render() {
    return (
      <svg
        width="19px"
        height="35px"
        viewBox="0 0 19 35"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g
          id="Page-1"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g
            id="Highlights"
            transform="translate(-1162.000000, -389.000000)"
            stroke="#3949AB"
          >
            <polyline
              id="arrow-right"
              transform="translate(1171.500000, 406.000000) scale(-1, 1) translate(-1171.500000, -406.000000) "
              points="1180 389 1163 406.228306 1180 423"
            />
          </g>
        </g>
      </svg>
    );
  }
}

class ArrowLeftMobile extends Component {
  render() {
    return (
      <svg
        width="15px"
        height="27px"
        viewBox="0 0 15 27"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g
          id="Page-1"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g
            id="Smartphone-Components"
            transform="translate(-28.000000, -3048.000000)"
            stroke="#FFFFFF"
          >
            <polyline
              id="arrow-left-copy"
              points="42 3048 29 3061.17459 42 3074"
            />
          </g>
        </g>
      </svg>
    );
  }
}

class ArrowRightMobile extends Component {
  render() {
    return (
      <svg
        width="15px"
        height="27px"
        viewBox="0 0 15 27"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g
          id="Page-1"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g
            id="Smartphone-Components"
            transform="translate(-277.000000, -3048.000000)"
            stroke="#FFFFFF"
          >
            <polyline
              id="arrow-left-copy-2"
              transform="translate(284.500000, 3061.000000) scale(-1, 1) translate(-284.500000, -3061.000000) "
              points="291 3048 278 3061.17459 291 3074"
            />
          </g>
        </g>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SetHeaderHighlights.js